export function isFlipperOn(flippers, flipperName) {
  return flippers && flippers.flippers && flippers.flippers[flipperName] && flippers.flippers[flipperName].enabled === true;
}